import { gql, MutationHookOptions, useMutation } from "@apollo/client"
import { HIRING_FORM_EMPLOYMENT_FIELDS_FRAGMENT } from "~/app/fragments/HiringFormEmploymentFields"
import {
  HiringFteCompanyUpdateEmploymentInformationAfterSubmissionMutation,
  HiringFteCompanyUpdateEmploymentInformationAfterSubmissionMutationVariables,
} from "~/app/gql/graphql"

const HIRING_FTE_COMPANY_UPDATE_EMPLOYMENT_INFORMATION_AFTER_SUBMISSION = gql`
  mutation HiringFTECompanyUpdateEmploymentInformationAfterSubmission(
    $input: UpdateEmploymentInformationAfterSubmissionInput!
  ) {
    updateEmploymentInformationAfterSubmission(input: $input) {
      employment {
        ...HiringFormEmploymentFields
      }
      errors
      fieldErrors {
        fieldId
        message
        target
      }
    }
  }
  ${HIRING_FORM_EMPLOYMENT_FIELDS_FRAGMENT}
`

export const useUpdateEmploymentInformationAfterSubmission = (
  options?: MutationHookOptions<
    HiringFteCompanyUpdateEmploymentInformationAfterSubmissionMutation,
    HiringFteCompanyUpdateEmploymentInformationAfterSubmissionMutationVariables
  >,
) => {
  return useMutation(HIRING_FTE_COMPANY_UPDATE_EMPLOYMENT_INFORMATION_AFTER_SUBMISSION, options)
}
